import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const reusability_metric = apiUrl + "/reusability_metric";

const routes = {
  label: "Reusability Metric",
  root: reusability_metric,
  get_by_product_id: reusability_metric + "/get_by_product_id",
  update_by_product_id: reusability_metric + "/update_by_product_id",
};

export const ReusabilityMetric = {
  label: routes.label,
  get_by_product_id: (product_id) => getWithToken(routes.get_by_product_id, { product_id }),
  update_by_product_id: (metric) => postWithToken(routes.update_by_product_id, metric),
};
